import { FC } from 'react';
import Page, { PageProps } from '../components/page';
import { useNavigate } from '@tanstack/react-router';
import { Box, Stack } from '@mui/material';
import FlatButton from '@/components/flat-button';

const NotFoundPage: FC<PageProps> = () => {
  const navigate = useNavigate();

  return (
    <Page title="Page Not Found">
      <Stack height="300px" width="100%" alignItems="center" justifyContent="center">
        <Box>Disassemble? Yes, disassemble ALL OVER THE PLACE!</Box>
        <Box mt={3}>
          <FlatButton
            icon="arrow-left"
            label="Go Back"
            color="link"
            onClick={() => {
              navigate({ to: '/' });
            }}
          />
        </Box>
      </Stack>
    </Page>
  );
};

export default NotFoundPage;
